import { jsx as _jsx } from "react/jsx-runtime";
import { useMemo } from 'react';
import { Chip } from '@mui/material';
export const environmentChipColors = {
    local: 'rgb(232,64,196)',
    test: 'rgb(77,163,9)',
    uat: 'rgb(31,114,211)',
    hotfix: 'rgb(235,133,14)',
    font: 'rgb(255,255,255)',
};
export const EnvironmentChip = ({ environmentName }) => {
    const chipBackgroundColor = useMemo(() => {
        switch (environmentName) {
            case 'local': {
                return environmentChipColors.local;
            }
            case 'test': {
                return environmentChipColors.test;
            }
            case 'uat': {
                return environmentChipColors.uat;
            }
            case 'hotfix': {
                return environmentChipColors.hotfix;
            }
        }
    }, [environmentName]);
    return (_jsx(Chip, { style: {
            backgroundColor: chipBackgroundColor,
            textTransform: 'uppercase',
            color: environmentChipColors.font,
            margin: '0 0.5rem',
            fontWeight: 500,
        }, label: environmentName }));
};
